export default "__VITE_ASSET__B6i78hcL__"